import { useQuery, useSuspenseQuery } from '@tanstack/react-query';
import { QUERY_KEYS } from '../consts';
import { getNonMemberPtInfo, sendNonMemberChgCncl } from '../api';

export const useSuspenseNonMemberPtInfo = (params) => {
  return useSuspenseQuery({
    queryKey: [QUERY_KEYS.nonMemberPtInfo],
    queryFn: getNonMemberPtInfo(params),
    staleTime: Infinity,
    refetchOnMount: false,
    refetchOnReconnect: false,
    refetchOnWindowFocus: false,
  });
};

export const useSendNonMemberChgCncl = (params) => {
  return useQuery({
    queryKey: [QUERY_KEYS.sendNonMemberChgCncl],
    queryFn: sendNonMemberChgCncl(params),
    staleTime: Infinity,
    refetchOnMount: false,
    refetchOnReconnect: false,
    refetchOnWindowFocus: false,
    enabled: false,
  });
};
